import { ArrowUpRight } from "lucide-react";
import {Link} from 'react-router-dom';

export default function NewHero() {
  return (
    <section>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-black text-4xl font-semibold md:text-4xl">
          Apply Now . Enterprise CloudSuite Consultant Role
        </h1>

        <h1 className="mt-4 text-4xl font-semibold md:text-4xl package-pop" style={{ color: '#1d4ed8' }}>
          OFFER LETTER @ ₹4.8 LPA*
        </h1>


        <h1
          className="mt-6 text-black font-semibold text-4xl md:text-4xl"
          style={{ lineHeight: "1.3" }}
        >
          Enterprise CloudSuite Consultant
        </h1>
        <p className="w-full max-w-3xl break-words px-1 text-sm font-normal leading-6 text-black sm:text-base md:text-xl md:leading-7">
          (Certification Preferred)
        </p>

        <h1 className="mt-6 mb-8 text-black font-semibold text-xl md:text-4xl" style={{color:'#1d4ed8'}}>
          ERP • IIoT • MES • Cloud • AI
        </h1>

        <p className="mt-3 w-full max-w-3xl break-words px-1 text-sm font-normal leading-6 text-black sm:mt-4 sm:text-base md:text-xl md:leading-7">
          The Industry 4.0 Revolution Needs You.
        </p>

        <p className="mt-3 w-full max-w-3xl break-words px-1 text-sm font-normal leading-6 text-black sm:mt-4 sm:text-base md:text-lg md:leading-7">
          For queries:{" "}
          <a
            href="mailto:hr@kapiltech.com"
            className="font-semibold text-[#1d4ed8] hover:underline"
          >
            hr@kapiltech.com
          </a>
        </p>

{/* 
                <Link onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                to="/careers/infor-cloud-suite-bootcamp/apply"
                className="mt-8 inline-flex items-center gap-2 bg-[#0D5EF4] hover:bg-[#004b82]
                text-white font-semibold px-10 py-4
                transition-all duration-300"
              >
                Apply Now
                <ArrowUpRight size={20} />
              </Link> */}
      </div>

      <style>
        {`
          .package-pop {
            display: inline-block;
            transform-origin: left center;
            animation: packagePop 1.6s ease-in-out infinite;
          }
          @keyframes packagePop {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.06); }
          }
        `}
      </style>
    </section>
  );
}
